import { Appearance } from '@/types';
import { isBrightColor } from '@/utils/colors/isBrightColor';

export const getDefaultColor = (appearance: Appearance) =>
  isBrightColor(appearance.colors[0].value) ? '#000000' : '#FFFFFF';
